// styledComponents.js
import styled from "styled-components";

export const RegisterButton = styled.button`
  background-color: ${(props) =>
    props.isDarkMode ? "transparent" : "#f1f1f1"};
  border: 1px solid #47b147;
  border-radius: 10px;
  color: #0ab635;
  cursor: pointer;
  outline: none;
  font-size: 15.2px;
  font-weight: bold;
  font-family: Arial;
  padding: 10px 20px;
  transition: all 0.3s ease-in;
  &:hover {
    background-color: #00d46a;
    color: #f6f6f6;
    padding: 14px 24px;
    transition: 0.9s;

    color: rgba(255, 255, 255, 1);
    box-shadow: 0 5px 15px #0ab635;
  }
`;

